const MEDIA_ITEMS = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20trailer%20style%20scene%2C%20dramatic%20lighting%20with%20lens%20flare%2C%20epic%20film%20atmosphere%2C%20golden%20and%20crimson%20color%20grading%2C%20movie%20title%20card%20aesthetic%2C%20cinematic%20widescreen%20composition%2C%20no%20text&width=640&height=360&seq=media-01&orientation=landscape',
    title: '星际穿越2：新纪元',
    type: '官方预告片',
    duration: '2:35',
    desc: '年度科幻巨制震撼预告，宇宙冒险再启程',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20film%20trailer%20moment%20with%20intense%20character%20closeup%2C%20emotional%20cinematic%20portrait%2C%20warm%20dramatic%20lighting%2C%20movie%20preview%20style%2C%20deep%20shadows%2C%20no%20text&width=640&height=360&seq=media-02&orientation=landscape',
    title: '命运之轮',
    type: '精彩花絮',
    duration: '4:12',
    desc: '幕后拍摄花絮独家放送，主角畅谈角色感悟',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Animated%20film%20trailer%20scene%20with%20magical%20creatures%20in%20fantasy%20world%2C%20colorful%20cinematic%20lighting%2C%20epic%20adventure%20atmosphere%2C%20animation%20movie%20aesthetic%2C%20no%20text&width=640&height=360&seq=media-03&orientation=landscape',
    title: '龙之秘境',
    type: '终极预告',
    duration: '3:08',
    desc: '国漫年度巨制终极预告，龙族大战一触即发',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">精彩预告</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            即将上线的热门内容抢先预览
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-200/70 border border-background-300/30 hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-950/60 group-hover:bg-primary-500/80 transition-colors">
                    <i className="ri-play-fill text-foreground-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 text-[10px] font-medium rounded bg-background-950/70 text-foreground-50 whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[10px] font-medium text-accent-400 uppercase whitespace-nowrap">{item.type}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-100">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}